import type { ReactNode } from 'react';

/** Az Elemzés blokkja: cím, halk leírás, tartalom. A táblák mobilon a blokkon belül görgethetők. */
export function Blokk({ cim, leiras, className = '', children }: { cim: string; leiras?: string; className?: string; children: ReactNode }) {
  return (
    <section className={`min-w-0 overflow-x-auto rounded-[18px] border border-vonal bg-hatter px-4 py-[18px] sm:px-6 sm:py-[22px] ${className}`}>
      <h2 className="text-[17px] font-medium tracking-[-0.015em]">{cim}</h2>
      {leiras && <p className="mt-1 text-[13px] text-szoveg-halk">{leiras}</p>}
      {children}
    </section>
  );
}

/** Vízszintes sávlista: címke, sáv a legnagyobbhoz mérve, darabszám. */
export function SorLista({ sorok, szin, nev }: { sorok: readonly { cimke: string; db: number }[]; szin: 'arany' | 'smaragd'; nev: string }) {
  const legnagyobb = Math.max(1, ...sorok.map((s) => s.db));
  return (
    <ul aria-label={nev} className="mt-4 grid gap-3">
      {sorok.map((s) => (
        <li key={s.cimke} className="grid grid-cols-[minmax(0,7.5rem)_1fr_1.75rem] items-center gap-3 text-[13px] sm:grid-cols-[minmax(0,9.5rem)_1fr_2.25rem]">
          <span className="truncate" title={s.cimke}>{s.cimke}</span>
          <i aria-hidden className={`block h-2 rounded-full ${szin === 'arany' ? 'bg-masodlagos' : 'bg-kiemelt'} opacity-80`} style={{ width: `${Math.max(2, (s.db / legnagyobb) * 100)}%` }} />
          <b className="szam text-right font-medium">{s.db}</b>
        </li>
      ))}
    </ul>
  );
}

export function UresSor({ szoveg }: { szoveg: string }) {
  return <p className="mt-4 text-sm text-szoveg-halk">{szoveg}</p>;
}

/** Táblázat a látványterv szerint; a hívó adja a fejlécet (`j` = jobbra igazított) és a sorokat. */
export function Tabla({ nev, fej, children, minSzel = 560 }: { nev: string; fej: readonly { cim: string; j?: boolean }[]; children: ReactNode; minSzel?: number }) {
  return (
    <table aria-label={nev} className="mt-4 w-full border-collapse text-sm" style={{ minWidth: minSzel }}>
      <thead>
        <tr>{fej.map((f, i) => <th key={f.cim} scope="col" className={`pb-2 text-xs font-normal text-szoveg-halk ${f.j ? 'text-right' : 'text-left'} ${i > 0 ? 'pl-4' : ''}`}>{f.cim}</th>)}</tr>
      </thead>
      <tbody className="[&_td]:border-t [&_td]:border-vonal [&_td]:py-2.5 [&_td+td]:pl-4 [&_td.j]:text-right">{children}</tbody>
    </table>
  );
}

export function Cim({ nev, alcim }: { nev: string; alcim?: string }) {
  return <td><span className="block">{nev}</span>{alcim && <small className="block text-xs text-szoveg-halk">{alcim}</small>}</td>;
}
